import React from "react";
import ServiceForm from "./ServiceForm";

export default function EditService() {
    return <ServiceForm type="Edit" />;
}
